import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'

const chainEvent = (func, chainedFunc) => (...args) => {
  let funcReturnValue

  if (func) {
    funcReturnValue = func(...args)
  }

  if (chainedFunc && !args[0].defaultPrevented) {
    if (funcReturnValue !== undefined) {
      chainedFunc(funcReturnValue)
    } else {
      chainedFunc(...args)
    }
  }
}

const changeValue = format => evt => {
  if (evt?.target?.type === 'checkbox' || evt?.target?.type === 'radio') {
    return format(evt.target.checked)
  }

  if (evt?.target?.value !== undefined) {
    return format(evt.target.value)
  }

  return format(evt)
}

const HookFormHoc = (Field, fieldStateMap = {}) => {
  const DecoratedField =
    ({
       control,
       controllerProps: { defaultValue, ...controllerProps } = {},
       name,
       inputProps = {},
       format = v => v,
       parse = v => v,
       ...props
     }) => <Controller
      name={name}
      defaultValue={defaultValue === undefined ? '' : defaultValue}
      control={control}
      {...controllerProps}
      render={({field, fieldState, formState}) =>  {
        const chainedInputProps = {...inputProps, ...field, onChange: chainEvent(inputProps.onChange, chainEvent(changeValue(parse), field.onChange)), onBlur: chainEvent(inputProps.onBlur, chainEvent(changeValue(parse), field.onBlur)), value: format(field.value)}
        const fieldStateMapProps = {field, fieldState, formState, defaultValue, name, inputProps: chainedInputProps, valueFromProps: props.value}
        const error = fieldStateMap.error ? fieldStateMap.error(fieldStateMapProps) : fieldState && fieldState.error && fieldState.error.message
        const touched = fieldStateMap.touched ? fieldStateMap.touched(fieldStateMapProps) : (fieldState && fieldState.isTouched) || formState && formState.isSubmitted
        const initialValue = fieldStateMap.initialValue ? fieldStateMap.initialValue(fieldStateMapProps) : defaultValue || (formState.defaultValues && formState.defaultValues[name]) || ''
        const finalInputProps = fieldStateMap.inputProps ? fieldStateMap.inputProps(fieldStateMapProps) : chainedInputProps

        return (
          <Field
            name={name}
            inputProps={finalInputProps}
            inputRef={field.ref}
            error={error}
            touched={touched}
            initialValue={initialValue}
            {...props}
          />
        )}}
    />

  DecoratedField.propTypes = {
    ...Field.propTypes,
    control: PropTypes.object.isRequired,
    controllerProps: PropTypes.shape(Controller.propTypes)
  }

  return DecoratedField
}

export default HookFormHoc
